import React, { lazy, Suspense } from 'react';

const LazyAddExpanse = lazy(() => import('./AddExpanse'));

const AddExpanse = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyAddExpanse {...props} />
  </Suspense>
);

export default AddExpanse;
